import * as React from 'react';

import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';
// @ts-expect-error - imported from .js/.jsx file
import {CloneIcon} from 'shells/icon/svg/clone-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EyeIcon} from 'shells/icon/svg/eye-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from 'shells/icon/svg/trash-icon';

import type {LandingPageStubFragment} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {NamePageModal} from '../create-page/name-page-modal';
import {useDeleteLandingPage, useUndeleteLandingPage} from '../graphql/hooks';

import {PageThumbnailButtonCard} from './page-thumbnail-button-card';

type Props = {
    page: LandingPageStubFragment;
    isArchived: boolean;
};

export function LandingPageCard(props: Props) {
    const {page} = props;

    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const [isShowingDuplicate, setIsShowingDuplicate] = React.useState<boolean>(false);

    const actionMenuRef = React.useRef(null);

    const {deleteLandingPage} = useDeleteLandingPage(props.isArchived);

    const {undeleteLandingPage} = useUndeleteLandingPage(props.isArchived);

    let options;
    if (props.isArchived) {
        options = [
            {
                label: 'Restore',
                handleSelect: () => {
                    undeleteLandingPage(page.id);
                },
            },
        ];
    } else {
        options = [
            {
                label: 'View',
                handleSelect: () => {
                    appHistory.push(page.htmlUrlPath);
                },
                icon: <EyeIcon wrapWithDiv={false} size={18} />,
            },
            {
                label: 'Make a copy',
                handleSelect: () => {
                    setIsShowingDuplicate(true);
                },
                icon: <CloneIcon size={16} />,
            },
            {
                label: 'Archive',
                handleSelect: () => {
                    setIsConfirmingDelete(true);
                },
                icon: <TrashIcon wrapWithDiv={false} size={18} />,
                variant: 'destructive',
            },
        ];
    }

    return (
        <>
            <PageThumbnailButtonCard
                name={page.name}
                nutshellPublishedUrl={page.nutshellPublishedUrl}
                customPublishedUrl={page.customPublishedUrl}
                lastModifiedTime={page.lastModifiedTime}
                thumbnailUrl={page.thumbnailUrl}
                onClick={() => appHistory.push(page.htmlUrlPath)}
                // @ts-expect-error
                options={options}
                getActionMenuRef={(ref) => {
                    // @ts-expect-error
                    actionMenuRef.current = ref;
                }}
                backgroundColor={page.backgroundColor}
            />
            {isConfirmingDelete ? (
                <ConfirmationDialog
                    title='Are you sure you want to archive this page?'
                    message='Once archived, it will no longer be visible at its hosted URL.'
                    onCancel={() => setIsConfirmingDelete(false)}
                    onConfirm={() => {
                        deleteLandingPage(page.id).then(() => setIsConfirmingDelete(false));
                    }}
                />
            ) : undefined}
            {isShowingDuplicate ? (
                <NamePageModal
                    onClickBack={() => {
                        setIsShowingDuplicate(false);
                    }}
                    selectedStarterId={page.id}
                    name={`Copy of ${page.name}`}
                />
            ) : undefined}
        </>
    );
}
